<template>
  <v-card class="rounded-xl">
    <v-toolbar
      class="mt-4 custom-toolbar"
      elevation="0"
    >
      <v-text-field
        clearable
        hide-details
        prepend-inner-icon="mdi-magnify"
        :label="$t('commons.search')"
        v-model="search"
      ></v-text-field>
    </v-toolbar>
    <v-data-table
      class="ma-10"
      dense
      :headers="headers"
      :items="templates"
      :items-per-page="-1"
      :search="search"
      :single-expand="true"
      item-key="id"
    >
      <template #item.created_at="{ item }">
        {{ toDatetime(item.created_at) }}
      </template>
      <template v-slot:item.status="{ item }">
        <avs-chip>
          {{ item.status }}
        </avs-chip>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <avs-button
              v-on="on"
              v-bind="attrs"
              fab
              icon
              iconI="mdi-home-edit"
              label
              small
              color="primary"
              @click="handleEditCompany(item)"
            />
          </template>
          <span> Copy this template to another company</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <AdminEditCompany
      v-if="openEditCompany"
      v-model="openEditCompany"
      @confirm="handleConfirmCompany"
      @cancel="handleCancelDialog"
      :selectedItem="selectedItem"
    />
  </v-card>
</template>

<script>
import { toDatetime } from "@/utils/datetime"
import { TemplateService } from "@/services/documents"
import AdminEditCompany from "@/components/ri3/AdminEditCompany.vue"

export default {
  name: "AdminTemplates",
  components: { AdminEditCompany },
  data() {
    return {
      headers: [
        {
          text: "Company",
          value: "company.name",
          class: "min-width-150",
          sortable: true,
          filterable: true
        },
        {
          text: "Name",
          value: "name",
          class: "min-width-150",
          sortable: true
        },
        {
          text: "Type",
          value: "type.label",
          class: "min-width-150",
          sortable: true,
          filterable: true
        },
        {
          text: "Creation date",
          value: "created_at",
          class: "min-width-150",
          sortable: true,
          filterable: false
        },
        {
          text: "Status",
          value: "status",
          align: "center",
          sortable: true,
          filterable: true
        },
        {
          text: "Actions",
          value: "actions",
          align: "right",
          width: 90,
          sortable: false,
          filterable: false
        }
      ],
      openEditCompany: false,
      search: "",
      selectedItem: null,
      templates: []
    }
  },
  created() {
    this.fetchTemplate()
  },
  methods: {
    toDatetime,
    fetchTemplate() {
      TemplateService.getAllTemplate().then(response => {
        this.templates = response.results
        this.templates.map(v => {
          v["status"] = v.state.label
        })
      })
    },
    handleCancelDialog() {
      this.openEditCompany = false
    },
    handleConfirmCompany(company) {
      this.openEditCompany = false
      TemplateService.duplicate(this.selectedItem.id, company)
        .then(() => {
          this.$store.commit("app/message", { msg: "Operation success", color: "success" })
        })
        .finally(() => this.fetchTemplate())
    },
    handleEditCompany(item) {
      this.selectedItem = item
      this.openEditCompany = true
    }
  }
}
</script>
